import { Box } from "@mui/material";
import { getIcon, handleHtmlTags } from "@platformx/utilities";
import { format } from "date-fns";
import "./ContentTypeCard.css";

function ContentTypeCard(props: any) {
  const {
    background_content = {},
    Thumbnail = {},
    ContentType = "",
    PublishedDate = "",
  } = props?.content || {};
  const { Color = "" } = background_content;

  return (
    <Box sx={{ height: "inherit" }}>
      <div style={{ position: "relative", height: "inherit" }} className='content'>
        <div style={{ left: 0, top: 0, height: "100%", width: "100%", position: "absolute" }}>
          {Color ? (
            <div
              style={{
                backgroundColor: Color,
                width: "100%",
                objectFit: "cover",
                height: "100%",
              }}></div>
          ) : (
            <img
              src={Thumbnail.Url}
              style={{ width: "100%", objectFit: "cover", height: "100%" }}
              alt='thumbnail'
            />
          )}
        </div>
        <div
          style={{
            position: "relative",
            bottom: 0,
            left: 0,
            padding: "2% 3%",
            backgroundImage: "linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #000 100%)",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "end",
            minHeight: "200px",
          }}>
          <div>
            <span
              style={{
                fontSize: "12px",
                marginBottom: "0",
                fontWeight: "bold",
                color: "#fff",
                textTransform: "capitalize",
                display: "flex",
                alignItems: "center",
                borderBottom: " 1px solid",
                width: "max-content",
                paddingBottom: "8px",
              }}>
              {ContentType === "Quiz" ? (
                <img
                  src={getIcon(ContentType)}
                  alt='quiz'
                  style={{ height: "20px", marginRight: "10px" }}
                />
              ) : null}
              {ContentType === "Poll" ? (
                <img
                  src={getIcon(ContentType)}
                  alt='poll'
                  style={{ height: "20px", marginRight: "10px" }}
                />
              ) : null}
              {ContentType === "Article" ? (
                <img
                  src={getIcon(ContentType)}
                  alt='article'
                  style={{ height: "20px", marginRight: "10px" }}
                />
              ) : null}
              {ContentType === "Vod" || ContentType === "VOD" ? (
                <img
                  src={getIcon(ContentType)}
                  alt='Vod'
                  style={{ height: "20px", marginRight: "10px" }}
                />
              ) : null}
              {ContentType}
            </span>
            <span
              style={{
                fontSize: "14px",
                marginBottom: "0",
                fontWeight: "bold",
                color: "#fff",
                textTransform: "capitalize",
                WebkitLineClamp: 1,
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                wordWrap: "break-word",
              }}>
              {Thumbnail.Title}
            </span>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#fff !important",
                WebkitLineClamp: 2,
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                wordWrap: "break-word",
              }}>
              {handleHtmlTags(Thumbnail.Description)}
            </span>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#fff !important",
                WebkitLineClamp: 2,
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                wordWrap: "break-word",
              }}>
              {PublishedDate ? format(new Date(PublishedDate), "d:M:y | H:mm") : ""}
            </span>
          </div>
        </div>
      </div>
      <br />
    </Box>
  );
}
export default ContentTypeCard;
